import React from 'react'
  import { MDXTag } from '@mdx-js/tag'


  const layoutProps = {};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props);
    this.layout = null;
  }

  render() {
    const {
      components,
      ...props
    } = this.props;
    return <MDXTag name="wrapper" components={components}><MDXTag name="p" components={components}>{`Looking for accurate pricing on a POS system can be time consuming and downright frustrating. Our easy-to-use quote request tool allows you to:`}</MDXTag>
      <MDXTag name="ul" components={components}>
        <MDXTag name="li" components={components} parentName="ul">{`Define your needs in `}<MDXTag name="strong" components={components} parentName="li">{`under 3 minutes`}</MDXTag></MDXTag>
        <MDXTag name="li" components={components} parentName="ul">{`Sit back while qualified point of sale providers compete to win your business with custom pricing`}</MDXTag>
        <MDXTag name="li" components={components} parentName="ul">{`Save time, money and your sanity all from a single quote request form - it's that easy`}</MDXTag>
      </MDXTag>
           </MDXTag>;
  }

}
MDXContent.isMDXComponent = true;
export const _frontmatter = {};
      